import { render, staticRenderFns } from "./NewQuestionEdit.vue?vue&type=template&id=a11f0be4"
import script from "./NewQuestionEdit.vue?vue&type=script&lang=js"
export * from "./NewQuestionEdit.vue?vue&type=script&lang=js"
import style0 from "./NewQuestionEdit.vue?vue&type=style&index=0&id=a11f0be4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports